import { ADD_ROW } from './formName';

import { Button } from 'components/Button/Button';
import { OverlayModal } from 'components/OverlayModal/OverlayModal';
import { OverlayModalBody } from 'components/OverlayModal/OverlayModalBody';
import { OverlayModalFooter } from 'components/OverlayModal/OverlayModalFooter';
import { OverlayModalHeader } from 'components/OverlayModal/OverlayModalHeader';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { assoc } from 'ramda';
import { PureComponent } from 'react';
import { Field, SubmissionError, reduxForm } from 'redux-form';
import { handleSubmitFail } from 'utils/formValidation';
import { generateGuid } from 'utils/guid';
import handleEvent from 'utils/handleEvent';
import LayoutField from './LayoutField';

@reduxForm({
  form: ADD_ROW,
  enableReinitialize: true,
  onSubmitFail: handleSubmitFail('btn-save'),
})
export default class AddRowDialog extends PureComponent {
  static propTypes = {
    handleSubmit: PropTypes.func,
    msg: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
  };

  handleDoubleClickX = handleEvent((e) => {
    return this.props.handleSubmit((values) =>
      this.handleSubmit(assoc('layout', 'x', values)),
    )(e);
  });

  handleDoubleClickXX = handleEvent((e) => {
    return this.props.handleSubmit((values) =>
      this.handleSubmit(assoc('layout', 'xx', values)),
    )(e);
  });

  handleDoubleClickXXX = handleEvent((e) => {
    return this.props.handleSubmit((values) =>
      this.handleSubmit(assoc('layout', 'xxx', values)),
    )(e);
  });

  handleSubmit = (values) => {
    const { onSubmit } = this.props;
    const errors = {};
    // layout: 'xxx' | 'xx' 'x';
    const { layout } = values;
    if (!layout) {
      errors.layout = 'selectLayoutOption';
    }
    if (Object.keys(errors).length) {
      throw new SubmissionError(errors);
    }
    switch (layout) {
      case 'xxx': {
        const row = {
          key: generateGuid(),
          columns: [
            {
              className: 'col-xs-12 col-lg-4',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
            {
              className: 'col-xs-12 col-lg-4',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
            {
              className: 'col-xs-12 col-lg-4',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
          ],
        };
        return onSubmit(row);
      }
      case 'xx': {
        const row = {
          key: generateGuid(),
          columns: [
            {
              className: 'col-xs-12 col-lg-6',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
            {
              className: 'col-xs-12 col-lg-6',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
          ],
        };
        return onSubmit(row);
      }
      default: {
        const row = {
          key: generateGuid(),
          columns: [
            {
              className: 'col-xs-12',
              title: '',
              columnOrientation: 'vertical',
              widgets: [],
            },
          ],
        };
        return onSubmit(row);
      }
    }
  };

  handleClose = (e) => {
    e.preventDefault();
    this.props.onClose();
  };

  render() {
    const { submitting, msg, onClose } = this.props;
    return (
      <OverlayModal onClose={onClose}>
        <OverlayModalHeader>
          <h4>{get(msg, ['dialog', 'addRowTitle'])}</h4>
        </OverlayModalHeader>
        <OverlayModalBody>
          <form>
            <fieldset disabled={submitting}>
              <div className='form-group'>
                <Field
                  autoFocus
                  block
                  component={LayoutField}
                  id={`${ADD_ROW}-layout-x`}
                  msg={msg}
                  name='layout'
                  onSelect={this.handleDoubleClickX}
                  type='radio'
                  value='x'
                />
                <Field
                  autoFocus
                  block
                  component={LayoutField}
                  id={`${ADD_ROW}-layout-xx`}
                  msg={msg}
                  name='layout'
                  onSelect={this.handleDoubleClickXX}
                  type='radio'
                  value='xx'
                />
                <Field
                  autoFocus
                  block
                  component={LayoutField}
                  id={`${ADD_ROW}-layout-xxx`}
                  msg={msg}
                  name='layout'
                  onSelect={this.handleDoubleClickXXX}
                  type='radio'
                  value='xxx'
                />
              </div>
            </fieldset>
          </form>
        </OverlayModalBody>
        <OverlayModalFooter>
          <Button
            variant='secondary'
            className='mr-2'
            onClick={this.handleClose}
            type='button'
          >
            {get(msg, ['dialog', 'btnClose'])}
          </Button>
        </OverlayModalFooter>
      </OverlayModal>
    );
  }
}
